export const ACTIVE_COLORS = ['#8B2C56', '#327569', '#45598C'];
export const IN_ACTIVE_COLORS = ['#E1E9EC', '#E1E9EC', '#E1E9EC'];
export const inActiveColor = '#E1E9EC';
export const SECTOR_INACTIVE_COLOR = '#C1CFD6';
export const CENTER_COUNT_COLOR = '#0E1212';
export const CENTER_TEXT_COLOR = '#506268';
export const PATH_CIRCLE_COLOR = '#A0B0B5';
